/*eslint-disable*/
import styled from 'styled-components';
import * as Ai from 'react-icons/ai';
import { CommonInput, RegularButton } from 'pg-ui-library';

export const DependentsApprovalContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DependentsApprovalContent = styled.div`
  background-color: white;
  border-radius: 20px;
  height: 90%;
  padding: 40px;
  margin-bottom: 40px;
`;

export const DependentsApprovalHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const DependentsApprovalTitleComponent = styled.div``;

export const DependentsApprovalButtons = styled.div``;

export const DependentsApprovalTitle = styled.h3``;

export const DependentsApprovalCollapsable = styled.div`
  width: 97.9%;
  background-color: #4948ac;
  color: white;
  padding: 1px;
  padding-left: 20px;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
`;

export const DependentsApprovalCollapsableLeft = styled.div``;

export const DependentsApprovalCollapsableTitle = styled.p``;

export const DependentsApprovalCollapsableRight = styled.div`
  margin-top: 20px;
  margin-right: 20px;
`;

export const DependentsApprovalCollapseActive = styled.div`
  margin-left: 1px;
  padding: 20px;
  height: 345px;
  width: 1043px;
  box-shadow: 0.1px 0.1px 30px rgba(0, 0, 0, 0.4);
`;

export const DependentsApprovalCollapseActiveFirstRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const DependentsApprovalCollapseActiveSecondRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const DependentsApprovalCollapseActiveThirdRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const DependentsApprovalCollapseActiveFourthRow = styled.div`
  display: flex;
`;

export const DependentsApprovalCollapseActiveLargeInput = styled(CommonInput)`
  width: 393px;
  border: 1px solid rgba(0, 0, 0, 0.6);
`;

export const DependentsApprovalCollapseActiveNormalInput = styled(CommonInput)`
  width: 190px;
  border: 1px solid rgba(0, 0, 0, 0.6);
`;

export const DependentApproveButtonGroup = styled.div`
  margin-top: 18px;
  margin-left: 20px;
  display: flex;
`;

export const DependentApproveToolTip = styled.div`
  position: absolute;
  right: 166px;
  background: white;
  color: black;
  padding: 10px;
  top: 110px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  border-bottom-right-radius: 0;
`;

export const DependentsApprovalCollapseApproveButton = styled(RegularButton)`
  background: green;
  color: white;
  max-width: 170px;
  min-width: 170px;
  border: 2px green solid;
  text-align: center;
  &:hover {
    background: white;
    color: green;
  }
`;
export const DependentsApprovalCollapseDeclineButton = styled(RegularButton)`
  background: #fff;
  color: red;
  border: 1px red solid;
  max-width: 170px;
  min-width: 170px;
  text-align: center;
  &:hover {
    background: red;
    color: white;
  }
`;

export const DependentsApprovalCollapsableRightIcon = styled(Ai.AiFillCaretDown)`
  &:hover {
    cursor: pointer;
  }
`;

export const DependentsApprovalCollapsableRightEyeIcon = styled(Ai.AiOutlineEye)`
  margin-top: -8px;
  margin-right: 20px;
  height: 30px;
  font-size: 20pt;
  &:hover {
    cursor: pointer;
  }
`;

export const DependentsApprovalCollapsableRightEyeClosedIcon = styled(Ai.AiOutlineEyeInvisible)`
  margin-top: -8px;
  margin-right: 20px;
  height: 30px;
  font-size: 20pt;
  &:hover {
    cursor: pointer;
  }
`;

export const DependentsApprovalCollapsableRightIconUp = styled(Ai.AiFillCaretUp)`
  margin-bottom: 3px;
  &:hover {
    cursor: pointer;
  }
`;
